import { storeCustomer } from "@/stores/customer.js";
import $axios from "@/axios";
import router from "@/router";

export default {
  //請求所有顧客
  getAll: async function (path, query, perPage = storeCustomer.perPage) {
    await $axios
      .post("/api/admin/customer_get_all.php", {
        query: query,
        perPage: perPage,
      })
      .then(function (res) {
        if (res.data.result == "pass") {
          storeCustomer.customers = res.data.customers;
          storeCustomer.page = res.data.page;
          storeCustomer.pageCount = res.data.page_count;
          if (JSON.stringify(query) != "{}" && query !== undefined) {
            if (query.page !== undefined) {
              if (parseInt(query.page) !== parseInt(res.data.page)) {
                let cloneQuery = JSON.parse(JSON.stringify(query));
                cloneQuery.page = parseInt(res.data.page);
                router.replace({ path: path, query: cloneQuery });
              }
            }
          }
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },

  getCurrentCustomer: async function (customerId) {
    await $axios
      .post("/api/admin/customer_get_current_customer.php", {
        id: customerId,
      })
      .then(function (res) {
        if (res.data.result == "pass") {
          storeCustomer.currentCustomer = res.data.customer;
          storeCustomer.pagination.credits = res.data.pagination.credits;
          storeCustomer.pagination.points = res.data.pagination.points;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },

  getCustomerCredits: async function (customerId, page) {
    await $axios
      .post("/api/admin/customer_get_credits_or_points.php", {
        customer_id: customerId,
        page: page,
        table_name: "customer_credits",
      })
      .then(function (res) {
        if (res.data.result == "pass") {
          storeCustomer.currentCustomer.credits = res.data.credits;
          storeCustomer.currentCustomer.total_credits = res.data.total_credits;
          storeCustomer.pagination.credits = res.data.pagination.credits;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },

  getCustomerPoints: async function (customerId, page) {
    await $axios
      .post("/api/admin/customer_get_credits_or_points.php", {
        customer_id: customerId,
        page: page,
        table_name: "customer_points",
      })
      .then(function (res) {
        if (res.data.result == "pass") {
          storeCustomer.currentCustomer.points = res.data.points;
          storeCustomer.currentCustomer.total_points = res.data.total_points;
          storeCustomer.pagination.points = res.data.pagination.points;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
